import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { FormModal } from '../basicForm/FormModal'
import { NoDataCard } from '../../common/NoDataCard'

export const Expenses = ({
  defaultData,
  envData,
  routeData,
  modSchema = JSON.parse(routeData.apiEndPointSchema),
  authDetails,
  isLocalEnvironment,
}) => {
  const [openFormModal, setOpenFormModal] = React.useState(false)
  const [editFormModal, setEditFormModal] = React.useState(false)
  const [selectEditFormModal, setSelectEditFormModal] = React.useState(null)

  function limitText(text, limit) {
    return text.length > limit ? text.substring(0, limit) : text
  }

  const openEditForm = (data) => {
    setSelectEditFormModal(data)
    setEditFormModal(true)
  }

  const closeEditForm = () => {
    setSelectEditFormModal(null)
    setEditFormModal(false)
  }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">Expenses</h4>
            <div className="trtui-page-title-right">
              <button
                type="button"
                className="trtui-btn trtui-btn-secondary trtui-add-btn"
                onClick={() => setOpenFormModal(true)}
              >
                <i className="ri-add-line align-bottom me-1"></i> Add
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="trtui-row">
        <div className="trtui-col trtui-project-card">
          <div className="trtui-card trtui-card-height-100">
            <div className="trtui-card-body">
              <table
                className="trtui-table trtui-table-responsive trtui-align-middle"
                id="orderTable"
              >
                <thead className="trtui-text-muted trtui-table-light">
                  <tr className="trtui-text-uppercase trtui-fs-13">
                    <th data-sort="id">Account</th>
                    <th data-sort="customer_name">Amount</th>
                    <th data-sort="product_name">Mode</th>
                    <th data-sort="date">Date</th>
                    <th data-sort="amount">Description</th>
                    <th data-sort="city">Action</th>
                  </tr>
                </thead>
                <tbody className="trtui-list trtui-form-check-all">
                  {defaultData.formData?.length <= 0 ? (
                    <div className="trtui-col-12 trtui-project-card">
                      <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
                    </div>
                  ) : (
                    defaultData.formData?.map((exp, expInd) => (
                      <tr key={expInd}>
                        <td className="trtui-customer_name">{exp.expenseAccountName}</td>
                        <td className="trtui-amount">{parseInt(exp.expenseAmount).toFixed(2)}</td>
                        <td className="trtui-status">
                          <span className="trtui-badge trtui-bg-danger-subtle trtui-text-danger trtui-text-uppercase">
                            {exp.expensePaymentType}
                          </span>
                        </td>
                        <td className="trtui-date">
                          {dayjs(exp.createdDateTime).format('MMMM D, YYYY')}{' '}
                          <small className="trtui-text-muted">
                            {dayjs(exp.createdDateTime).format('h:mm A')}
                          </small>
                        </td>
                        <td className="trtui-product_name">
                          {limitText(exp.expenseRemarks, 20)}...
                        </td>
                        <td>
                          <ul className="trtui-list-inline trtui-hstack trtui-gap-2 trtui-mb-0">
                            <li
                              className="trtui-list-inline-item trtui-edit"
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-placement="top"
                              aria-label="Edit"
                              data-bs-original-title="Edit"
                            >
                              <a
                                href="#showModal"
                                data-bs-toggle="modal"
                                className="trtui-text-primary trtui-d-inline-block trtui-edit-item-btn"
                                onClick={() => openEditForm(exp)}
                              >
                                <i className="ri-pencil-fill trtui-fs-16" />
                              </a>
                            </li>
                            <li
                              className="trtui-list-inline-item"
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-placement="top"
                              aria-label="Remove"
                              data-bs-original-title="Remove"
                            >
                              <a
                                className="trtui-text-danger trtui-d-inline-block trtui-remove-item-btn"
                                data-bs-toggle="modal"
                                href="#deleteOrder"
                              >
                                <i className="ri-delete-bin-5-fill trtui-fs-16" />
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {openFormModal && (
        <FormModal
          setOpenFormModal={setOpenFormModal}
          crud={4}
          envData={envData}
          formSchema={modSchema.form.create}
          modSchema={modSchema}
          moduleSchema={modSchema}
          isAdd={true}
          authDetails={authDetails}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
      {editFormModal && (
        <FormModal
          setOpenFormModal={closeEditForm}
          formSchema={modSchema.form.update}
          modSchema={modSchema.form.update}
          defaultData={selectEditFormModal}
          isViewOnly={false}
          envData={envData}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
    </React.Fragment>
  )
}

Expenses.propTypes = {
  defaultData: PropTypes.object,
  envData: PropTypes.object,
  routeData: PropTypes.object,
  authDetails: PropTypes.object,
  modSchema: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
}
